/**
 * Hub GL `source_batch_id` printable-ASCII pattern.
 *
 * One string. This file must not import zod or anything that does — GRANT
 * (17) extracted it from `index.ts` so the operator portal can import the
 * pattern without the schema graph. Value stays `^[!-~]{1,128}$`; do not
 * narrow or widen. Do not add a second constant here.
 *
 * Re-exported from `index.ts` for existing `@gv/contracts` consumers.
 */
export const HUB_SOURCE_BATCH_ID_PATTERN = "^[!-~]{1,128}$";
